import { useNavigate } from "react-router-dom";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    MenuItem,
    Select,
    Box,
    Button,
    SelectChangeEvent,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import React from "react";

const ServiceListing = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [serviceStatus, setServiceStatus] = useState<{ [key: string]: string }>({});

    const handleStatusChange = (id: string, event: SelectChangeEvent) => {
        setServiceStatus((prev) => ({ ...prev, [id]: event.target.value }));
    };

    const services = [
        {
            id: "#SERV-001",
            name: "House Cleaning",
            category: "Home Services",
            subCategory: "Cleaning",
            price: 25,
            priceUnit: "hourly",
            duration: "2 hours",
            status: "Active",
            bookings: 150,
        },
        {
            id: "#SERV-002",
            name: "AC Repair",
            category: "Appliance Repair",
            subCategory: "Air Conditioner",
            price: 100,
            priceUnit: "fixed",
            duration: "N/A",
            status: "Pending",
            bookings: 45,
        },
        {
            id: "#SERV-003",
            name: "Personal Training",
            category: "Health & Fitness",
            subCategory: "Fitness",
            price: 300,
            priceUnit: "package",
            duration: "1 Month",
            status: "Inactive",
            bookings: 30,
        },
    ];

    // Filter services by search term (case-insensitive search by name)
    const filteredServices = services.filter((service) =>
        service.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className="main_title ">
                <h1>Service Listings Management</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    Manage Services
                </p>
            </div>
            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search by service name..."
                        />
                    </div>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={() => navigate("add")}
                        >
                            <AddIcon /> Add Service
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container" sx={{ mt: 3 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No</TableCell>
                                <TableCell>Service Name</TableCell>
                                <TableCell>Category</TableCell>
                                <TableCell>Sub-category</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell>Duration</TableCell>
                                <TableCell>Service Status</TableCell>
                                <TableCell>Number of Bookings</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredServices.map((service, index) => (
                                <TableRow key={service.id} hover>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{service.name}</TableCell>
                                    <TableCell>{service.category}</TableCell>
                                    <TableCell>{service.subCategory}</TableCell>
                                    <TableCell>
                                        {service.price} {service.priceUnit}
                                    </TableCell>
                                    <TableCell>{service.duration}</TableCell>
                                    <TableCell>
                                        <div className="form">
                                            <Select
                                                value={serviceStatus[service.id] || service.status}
                                                onChange={(e) => handleStatusChange(service.id, e)}
                                                size="small"
                                                fullWidth
                                            >
                                                <MenuItem value="Active">Active</MenuItem>
                                                <MenuItem value="Inactive">Inactive</MenuItem>
                                                <MenuItem value="Pending">Pending</MenuItem>
                                            </Select>
                                        </div>
                                    </TableCell>
                                    <TableCell>{service.bookings}</TableCell>
                                    <TableCell>  <div className="table_actions v2">

                                        <Box>

                                            <IconButton onClick={() => navigate("view")}>
                                                <img src="/static/images/eye_icon.svg" alt="View" />
                                            </IconButton>
                                            <IconButton onClick={() => navigate("add")}>
                                                <img src="/static/images/edit2_icon.svg" alt="View" />
                                            </IconButton>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="View" />
                                            </IconButton>

                                        </Box>
                                    </div></TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default ServiceListing;
